import React, { useRef, useEffect, useState } from "react";
import "./CardStack.css";
import AIPowered from "../../assets/AIPowered.png";
import UploadToAss from "../../assets/UploadToAss.png";
import UpoadREVIEW from "../../assets/UpoadREVIEW.png";
import MarketPlace from "../../assets/MarketPlace.png";
import CheckREV from "../../assets/CheckREV.png";
import DroneT from "../../assets/DroneT.png";
import DroneCap from "../../assets/DroneCap.png";
import AssEy from "../../assets/AssEy.png";
import AIPWR from "../../assets/AIPWR.png";
import RVW from "../../assets/RVW.png";
import MRTB from "../../assets/MRTB.png";
import RPRC from "../../assets/RPRC.png";
import BackWeb from "../../assets/BackWeb.svg";
import { useTranslation } from "react-i18next";

// in vh

function getCardState(index, currentIndex) {
  if (index === currentIndex) return "current";
  if (index < currentIndex) {
    return currentIndex - index === 1 ? "previous" : "far-previous";
  }
  return "next";
}

export default function CardStack() {
  const { t } = useTranslation();
  const CARDS = [
    {
      id: 1,
      icon: <img src={DroneT} alt="Drone Capture" />,
      title: t("cards.card1.title"),
      description: t("cards.card1.description"),
      image1: DroneCap,
    },
    {
      id: 2,
      icon: <img src={UploadToAss} alt="Upload to Assistant" />,
      title: t("cards.card2.title"),
      description: t("cards.card2.description"),
      image1: AssEy,
    },
    {
      id: 3,
      icon: <img src={AIPowered} alt="AI Powered" />,
      title: t("cards.card3.title"),
      description: t("cards.card3.description"),
      image1: AIPWR,
    },
    {
      id: 4,
      icon: <img src={UpoadREVIEW} alt="Upload Review" />,
      title: t("cards.card4.title"),
      description: t("cards.card4.description"),
      image1: RVW,
    },
    {
      id: 5,
      icon: <img src={MarketPlace} alt="Marketplace Bidding" />,
      title: t("cards.card5.title"),
      description: t("cards.card5.description"),
      image1: MRTB,
    },
    {
      id: 6,
      icon: <img src={CheckREV} alt="Check Review" />,
      title: t("cards.card6.title"),
      description: t("cards.card6.description"),
      image1: RPRC,
    },
  ];

  const sectionRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const SECTION_HEIGHT = CARDS.length * 100;

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const scrollTop = window.pageYOffset;
      const sectionTop = sectionRef.current.offsetTop;
      const sectionHeight = sectionRef.current.offsetHeight;
      const windowHeight = window.innerHeight;
      if (
        scrollTop >= sectionTop - windowHeight / 2 &&
        scrollTop <= sectionTop + sectionHeight - windowHeight / 2
      ) {
        const relativeScroll = scrollTop - sectionTop + windowHeight / 2;
        const cardHeight = sectionHeight / CARDS.length;
        const newIndex = Math.floor(relativeScroll / cardHeight);
        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < CARDS.length) {
          setCurrentIndex(Math.max(0, Math.min(CARDS.length - 1, newIndex)));
        }
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
    // eslint-disable-next-line
  }, [currentIndex]);

  return (
    <section
      className="stacking-section"
      ref={sectionRef}
      style={{
        position: "relative",
        width: "100%",
        height: `${SECTION_HEIGHT}vh`,
        background: `url(${BackWeb}) center/cover no-repeat fixed, #f8fafc`,
        margin: 0,
        padding: 0,
      }}
    >
      {/* Header Section */}
      <div className="w-full flex flex-col items-center justify-center pt-[8rem]">
        <h2 className="font-arya text-3xl md:text-4xl font-bold mb-2 text-center">
          Capture. Analyze. Annotate. Bid. Repair{" "}
          <span className="text-green-700"> — All in One Seamless Workflow.</span>
        </h2>
      </div>
      <div className="cards-container">
        {CARDS.map((card, i) => (
          <div key={i} className={`card ${getCardState(i, currentIndex)}`} data-index={i}>
            <div
              className="card-content"
              style={{ display: "flex", alignItems: "stretch", gap: "1rem" }}
            >
              {/* Left: Icon, Title, Description */}
              <div className="flex flex-1 flex-col items-start">
                <span className="mb-2 text-3xl text-blue-600">{card.icon}</span>
                <h5 className="m-0 font-bold mb-2 text-xl">{card.title}</h5>
                <h5 className=" text-left text-[14px] text-gray-600 m-0">{card.description}</h5>
              </div>
              {/* Right: Image (same as icon for now, replace as needed) */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <img
                  src={card.image1}
                  alt={card.title}
                  style={{ width: 120, height: 120, objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
